module.exports = __webpack_public_path__ + "static/media/spacex.9eec8e7f.jpg";